<template>
  <div>
    <!-- Evasione -->
    <v-bottom-nav
      v-if="getLink == '/evasione'"
      class="bottom-nav-fixed"
      :active.sync="bottomNav"
      :value="true"
      color="white"
      fixed
    >
      <v-btn flat value="daEvadere" @click="goto('/evasione','daEvadere')" color="primary">
        <span>Da Evadere</span>
        <v-icon>archive</v-icon>
      </v-btn>
      <v-btn flat value="evaso" @click="goto('/evasione','evaso')" color="primary">
        <span>Evasi</span>
        <v-icon>unarchive</v-icon>
      </v-btn>
    </v-bottom-nav>

    <!-- Ricevimento -->
    <v-bottom-nav
      v-if="getLink == '/ricevimento'"
      class="bottom-nav-fixed"
      :active.sync="bottomNav"
      :value="true"
      color="white"
      fixed
    >
      <v-btn flat value="daRicevere" @click="goto('/ricevimento','daRicevere')" color="primary">
        <span>Da ricevere</span>
        <v-icon>archive</v-icon>
      </v-btn>
      <!-- <v-btn flat value="ricevuto" @click="goto('/ricevimento','ricevuto')" color="primary">
        <span>Ricevuti</span>
        <v-icon>archive</v-icon>
      </v-btn> -->
    </v-bottom-nav>

    <!-- Consegne -->
    <v-bottom-nav
      v-else-if="getLink == '/consegne'"
      class="bottom-nav-fixed"
      :active.sync="bottomNav"
      :value="true"
      color="white"
      fixed
    >
      <v-btn flat value="daConsegnare" @click="goto('/consegne','daConsegnare')" color="primary">
        <span>Da consegnare</span>
        <v-icon>local_shipping</v-icon>
      </v-btn>
      <v-btn flat value="consegnato" @click="goto('/consegne','consegnato')" color="primary">
        <span>Consegnati</span>
        <v-icon>beenhere</v-icon>
      </v-btn>
    </v-bottom-nav>

    <!-- Maniglie -->
    <v-bottom-nav
      v-if="getLink == '/maniglie'"
      class="bottom-nav-fixed"
      :active.sync="bottomNav"
      :value="true"
      color="white"
      fixed
    >
      <v-btn flat value="daRicevere"  color="primary">
        <span>Da prelevare</span>
        <v-icon>archive</v-icon>
      </v-btn>

    </v-bottom-nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bottomNav: ""
    };
  },

  methods: {
    goto(link, tipo) {
      this.$emit("goto", link, tipo);
    }
  },

  computed: {
    getLink() {
      return this.$store.getters["app/getLink"];
    },

    getTipo() {
      return this.$store.getters["app/getTipo"];
    }
  },

  watch: {
    getTipo(v) {
      //console.log("watch : " + v);

      this.bottomNav = v;
    }
  }
};
</script>